//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
import passageUserManager from "@/Manager/09.Cm/PassageUserManager";
export default {
  components: { work_bench_item },
  data() {
    return {
      passageUser: {},
      actionTitle: "",
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: "选择盘库方式",
        actions: [
          {
            name: "1.直接扫码盘库",
            url: this.$api.host + "/mDms/DealerStockCheckOrder/Scan"
          },
          {
            name: "2.分次扫码盘库",
            url: this.$api.host + "/mDms/SubStockOrder/Index"
          },
          {
            name: "3.多人扫码盘库",
            url: this.$api.host + "/mDms/SubStockOrder2/Index"
          }
        ]
      },
      work_bench_item1: [
        {
          img: "images/1_15.png",
          text: "扫码入库",
          link: this.$api.host + "/mDms/DealerStockInBuyOrder/Scan"
        },
        {
          img: "images/1_26.png",
          text: "一键入库",
          link:
            this.$api.host +
            "/mDms/StoreStockOutSalesOrder/WaitingReceiveIndex"
        },
        {
          img: "images/1_19.png",
          text: "我要出库",
          link: this.$api.host + "/mDms/DealerStockOutSalesOrder/SetTo"
        },
        {
          img: "images/1_23.png",
          text: "我要盘点",
          action: "stockCount"
        }
      ],
      work_bench_item2: [
        {
          img: "images/31_07.png",
          text: "我的金额",
          link: this.$api.host + "/mCc/PassageUserCashInOrder/Index"
        },
        {
          img: "images/31_11.png",
          text: "金额记录",
          link: this.$api.host + "/mCc/PassageUserCashDataLog/Index",
          hide_border: true
        },
        {
          img: "images/31_07.png",
          text: "我的积分",
          link: "/mDms/myPoints"
        },
        {
          img: "images/31_11.png",
          text: "积分记录",
          link: "/mDms/myPointsHistory"
        }
      ],
      work_bench_item3: [
        {
          img: "images/2_03.png",
          text: "我的订单",
          link: this.$api.host + "/mDms/StoreStockOutSalesOrder"
        }
      ],
      work_bench_item4: [
        {
          img: "images/1_30.png",
          text: "库存查看",
          link: this.$api.host + "/mDms/DealerStockData/Index"
        },
        {
          img: "images/1_26.png",
          text: "门店库存",
          link: this.$api.host + "/mDms/ShopStockData/ShopIndex",
          hide_border: true
        }
      ],
      work_bench_item5: [
        {
          img: "images/1_32.png",
          text: "公告信息",
          link: this.$api.host + "/mDms/Notice",
          hide_border: true
        }
      ]
    };
  },
  computed: {},

  async created() {
    this.passageUser = this.$appBox.getPassageUser();

    if(this.passageUser.PassageUserType==81||this.passageUser.PassageUserType==82){
      const workBenchUrl = "/Sms/Workbench";
      const bindWechatUrl = "/Sms/PassageUser/BindWechat";
      await passageUserManager.checkPassageUserData(this,workBenchUrl,bindWechatUrl);
    }else if(this.passageUser.PassageUserType==18||this.passageUser.PassageUserType==19){
      const workBenchUrl = "/Gms/Workbench";
      const bindWechatUrl = "/Gms/PassageUser/BindWechat";
      await passageUserManager.checkPassageUserData(this,workBenchUrl,bindWechatUrl);
    }
    //this.$wxConfig()
  },

  methods: {
    goGuideRightsPage() {
      this.$router.push("/mGms/guideRights");
    },
    goPage(link) {
      if (link) {
        window.location = this.$api.host + link;
        this.$toast({
          type: "loading",
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "加载中"
        });
      }
    },
    stockCount() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet1.title;
      this.actionList = this.actionSheet1.actions;
    },
    onSelect(item) {
      console.log(item);
      if (item.url) {
        if (item.url.indexOf("http") == -1) {
          this.$router.push(item.url);
        } else {
          window.location = item.url;
          this.$toast({
            type: "loading",
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
        }
      }
    },
    onClickScanBtn() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log("开始扫码", res1);
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
